import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgXrpl = function SvgXrpl(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M37.322 32.91h1.528V29h-1.528a12.4 12.4 0 0 0-4.723.931 12.3 12.3 0 0 0-4.003 2.66 12.3 12.3 0 0 0-2.674 3.984 12.2 12.2 0 0 0-.936 4.7v8.906a7.37 7.37 0 0 1-2.017 5.075A7.44 7.44 0 0 1 18 57.567l.11 1.955-.11 1.956c1.892.11 3.67.938 4.969 2.31a7.37 7.37 0 0 1 2.017 5.076v10.264a12.82 12.82 0 0 0 3.763 9.09A12.95 12.95 0 0 0 37.867 92v-3.91a8.98 8.98 0 0 1-6.327-2.61 8.9 8.9 0 0 1-2.624-6.297v-10.32a11.24 11.24 0 0 0-1.316-5.285 11.3 11.3 0 0 0-3.65-4.056 11.4 11.4 0 0 0 3.642-4.06 11.3 11.3 0 0 0 1.324-5.281v-8.907a8.38 8.38 0 0 1 2.473-5.903 8.47 8.47 0 0 1 5.933-2.46M82.733 32.91h-1.528V29h1.528a12.34 12.34 0 0 1 8.694 3.608 12.22 12.22 0 0 1 3.587 8.666v8.907a7.37 7.37 0 0 0 2.017 5.075A7.44 7.44 0 0 0 102 57.567l-.109 1.955.109 1.956a7.44 7.44 0 0 0-4.969 2.31 7.37 7.37 0 0 0-2.017 5.076v10.264a12.82 12.82 0 0 1-3.763 9.09A12.95 12.95 0 0 1 82.133 92v-3.91a8.98 8.98 0 0 0 6.328-2.61 8.9 8.9 0 0 0 2.623-6.297v-10.32a11.23 11.23 0 0 1 1.316-5.285 11.3 11.3 0 0 1 3.65-4.056 11.4 11.4 0 0 1-3.642-4.06 11.3 11.3 0 0 1-1.324-5.281v-8.907a8.3 8.3 0 0 0-2.43-5.907 8.396 8.396 0 0 0-5.921-2.456M74.327 44.75h5.84L67.998 56.1a11.9 11.9 0 0 1-7.97 3.056 11.9 11.9 0 0 1-7.969-3.055L39.887 44.75h5.84l9.224 8.581A7.5 7.5 0 0 0 60 55.287c1.87 0 3.671-.698 5.049-1.956zM45.673 76.25h-5.84l12.226-11.405a11.8 11.8 0 0 1 7.968-3.096c2.953 0 5.797 1.105 7.969 3.096L80.222 76.25h-5.84l-9.279-8.69a7.5 7.5 0 0 0-5.048-1.956c-1.87 0-3.672.698-5.05 1.956z"
    })));
};

export { SvgXrpl as ReactComponent };
//# sourceMappingURL=XRPL.svg.es.js.map
